import { hasExpression } from './has-expression';

export const emailValidation = (value: string | undefined): string | undefined => {
	if (!value) {
		return 'No email has been provided.';
	}
	//If the value contains an expression we can skip regex validation as it will be validated at runtime
	if (hasExpression(value)) {
		return undefined;
	}
	const emailRegex = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/;
	if (emailRegex.test(value)) {
		return undefined;
	}
	return `${value} is not a valid email.`;
};
